import { format } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const TIMEZONE = 'Europe/Paris';

export const formatDate = (date) => {
  if (!date) return null;

  const zonedDate = zonedTimeToUtc(new Date(date), TIMEZONE);

  return format(zonedDate, 'dd.MM.yyyy');
};

export const formatDatetime = (datetime) => {
  if (!datetime) return null;

  const zonedDate = utcToZonedTime(new Date(datetime), TIMEZONE);

  return format(zonedDate, 'dd/MM/yyyy, H:mm');
};

export const formatTime = (time) => {
  if (!time) return null;

  const zonedTime = utcToZonedTime(new Date(time), TIMEZONE);

  return format(zonedTime, 'HH:mm');
};

export const parseDatetime = (datetime) => {
  if (!datetime) return null;

  return zonedTimeToUtc(new Date(datetime), TIMEZONE);
};

export const parseBirthdate = (birthdate) => {
  if (!birthdate) return;

  const utcDate = utcToZonedTime(birthdate, TIMEZONE);

  return format(utcDate, 'dd.MM.yyyy');
};

export const timeInParis = (datetime) => {
  if (!datetime) return;
  return utcToZonedTime(datetime, TIMEZONE);
};
